import { type BoxStaffLightDto, BoxStaffRole } from "@modules/boxStaff/gateway/boxStaffDto"
import { UserEntity } from "@modules/profile/userProfile/userEntity"
export type BoxStaffLightState = Omit<BoxStaffLightEntity, "getUserName">

export class BoxStaffLightEntity {
  staffMemberId: string
  staffMemberRole: BoxStaffRole
  user: UserEntity

  private constructor(boxStaffLightEntity: BoxStaffLightState) {
    this.staffMemberId = boxStaffLightEntity.staffMemberId
    this.staffMemberRole = boxStaffLightEntity.staffMemberRole
    this.user = boxStaffLightEntity.user
  }

  static fromDto(dto: BoxStaffLightDto): BoxStaffLightEntity {
    return new BoxStaffLightEntity({
      staffMemberId: dto.staffMemberId,
      staffMemberRole: dto.staffMemberRole,
      user: UserEntity.fromDto(dto.user),
    })
  }

  getUserName(): string {
    if (this.user.username === "") {
      return this.user.username
    }
    return "@" + this.user.username
  }
}
